import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const hamburger = document.getElementById('main-header__hamburger');
const mainNav = document.getElementById('main-nav');
const menuItemButtons = document.querySelectorAll('.main-nav__sub-menu-button');
const subMenus = document.querySelectorAll('.main-nav__sub-menu');
let previousWindowSize = window.innerWidth;
let resizeTimer; // eslint-disable-line no-unused-vars
let scrollTop = 0; // eslint-disable-line no-unused-vars
const scrollableElements = document.querySelectorAll(
	'.main-nav__menu, .main-nav__sub-menu'
);

const megaMenu = () => {
	if (hamburger && mainNav) {
		hamburger.addEventListener('click', toggleHamburger);
	}

	if (menuItemButtons.length > 0) {
		menuItemButtons.forEach(function (button) {
			button.addEventListener('click', toggleSubmenu);
		});
	}

	if (subMenus.length) {
		subMenus.forEach(function (subMenu) {
			const animatedMenuItems = subMenu.querySelectorAll(
				'.main-nav__menu-item--depth-1:not(.main-nav__menu-item--image)'
			);

			if (animatedMenuItems.length) {
				animatedMenuItems.forEach(function (menuItem, index) {
					menuItem.style.setProperty('--menuItemIndex', `${index}`);
				});
			}
		});
	}
};

const lockScroll = () => {
	if (scrollableElements.length) {
		scrollableElements.forEach(function (scrollableElement) {
			const storedRequestAnimationFrame = window.requestAnimationFrame;
			window.requestAnimationFrame = () => 42;

			disableBodyScroll(scrollableElement, { reserveScrollBarGap: true });
			window.requestAnimationFrame = storedRequestAnimationFrame;
		});
	}
};

const toggleHamburger = () => {
	hamburger.classList.toggle('active');

	closeSubmenus();

	if (hamburger.classList.contains('active')) {
		setScrollTop();
		document.body.classList.add('mega-menu-open');
		lockScroll();
		document.addEventListener('keydown', clickOffMenu);
	} else {
		closeHambuger();
	}
};

const toggleSubmenu = (e) => {
	e.preventDefault();

	if (e.currentTarget.parentElement.classList.contains('active')) {
		if (window.innerWidth >= 992) {
			closeSubmenus();
			removeBodyClasses();
		}

		e.currentTarget.parentElement.classList.remove('active');
		document.body.classList.remove('sub-menu-open');
	} else {
		if (
			e.currentTarget.classList.contains('main-nav__sub-menu-button') &&
			window.innerWidth >= 992
		) {
			closeSubmenus();

			if (
				e.currentTarget.parentElement.classList.contains(
					'main-nav__menu-item--dropdown'
				)
			) {
				document.body.classList.add('dropdown-menu-open');
			} else {
				document.body.classList.remove('dropdown-menu-open');
			}
		}

		setScrollTop();
		e.currentTarget.parentElement.classList.add('active');
		document.body.classList.add('mega-menu-open', 'sub-menu-open');
		lockScroll();

		if (window.innerWidth >= 992) {
			document.addEventListener('click', clickOffMenu);
			document.addEventListener('keydown', clickOffMenu);
		}

		document.documentElement.style.setProperty(
			'--subMenuHeight',
			`${e.currentTarget.nextElementSibling.offsetHeight}`
		);
	}
};

const closeHambuger = () => {
	closeSubmenus();

	hamburger.classList.remove('active');
	removeBodyClasses();
};

const closeSubmenus = () => {
	menuItemButtons.forEach(function (button) {
		if (button.parentElement.classList.contains('active')) {
			button.parentElement.classList.remove('active');
		}
	});

	document.body.classList.remove('sub-menu-open');

	if (window.innerWidth >= 992) {
		document.body.classList.remove('mega-menu-open');
	}

	document.removeEventListener('click', clickOffMenu);
	document.removeEventListener('keydown', clickOffMenu);

	document.documentElement.style.setProperty('--subMenuHeight', `0`);
};

const removeBodyClasses = () => {
	document.body.classList.remove(
		'mega-menu-open',
		'sub-menu-open',
		'dropdown-menu-open'
	);
	resetScrollPosition();
};

const resetScrollPosition = () => {
	clearAllBodyScrollLocks();

	if (scrollableElements.length) {
		resizeTimer = setTimeout(function () {
			scrollableElements.forEach(function (scrollableElement) {
				scrollableElement.scrollTop = 0;
			});
		}, 400);
	}
};

const resizeSubmenu = () => {
	if (document.body.classList.contains('mega-menu-open')) {
		const activeMenu = document.querySelector(
			'.main-nav__menu-item--sub-menu-button.active > .main-nav__sub-menu'
		);

		if (activeMenu) {
			document.documentElement.style.setProperty(
				'--subMenuHeight',
				`${activeMenu.offsetHeight}`
			);
		}
	}
};

const megaMenuResize = () => {
	if (document.body.classList.contains('mega-menu-open')) {
		resizeSubmenu();

		if (
			(previousWindowSize >= 992 && window.innerWidth < 992) ||
			(previousWindowSize < 992 && window.innerWidth >= 992)
		) {
			closeHambuger();
		}
	}

	document.body.classList.add('resizing');
	previousWindowSize = window.innerWidth;

	resizeTimer = setTimeout(function () {
		resizeSubmenu();
		document.body.classList.remove('resizing');
	}, 400);
};

const clickOffMenu = (e) => {
	if (
		(e.key === undefined && !mainNav.contains(e.target)) ||
		e.key === 'Escape'
	) {
		closeHambuger();
	}
};

const setScrollTop = () => {
	scrollTop = document.documentElement.scrollTop;
};

export { megaMenu, megaMenuResize };
